<script>
  import Modal from '@components/general/modal.svelte'
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import { Trash2 } from 'lucide-svelte'

  let {
    open = $bindable(false),
    title = 'Confirm deletion',
    message,
    warningMessage,
    confirmValue,
    confirmLabel = 'Type to confirm',
    buttonText = 'Delete',
    processing = false,
    onConfirm,
    onClose,
  } = $props()

  let confirmInput = $state('')
  let confirmed = $derived(
    confirmValue ? confirmInput.toLowerCase() === confirmValue.toLowerCase() : true
  )

  function handleConfirm() {
    onConfirm?.()
  }

  function handleClose() {
    open = false
    confirmInput = ''
    onClose?.()
  }
</script>

<Modal bind:open title={title} width="32rem" onClose={handleClose}>

  <div class="flex flex-col gap-4">

    {#if message}
      <Text class="text-gray-600">{message}</Text>
    {/if}

    {#if warningMessage}
      <Text class="text-red-500 underline">{warningMessage}</Text>
    {/if}

    {#if confirmValue}
      <div class="mt-2 flex flex-col gap-2">
        <label for="confirm-delete" class="text-sm text-gray-500 mb-1 block">
          {confirmLabel} <strong>{confirmValue}</strong> to confirm
        </label>
        <input id="confirm-delete" type="text" bind:value={confirmInput} placeholder={confirmValue} class="input w-full" autocomplete="off" />
      </div>
    {/if}

  </div>

  {#snippet footer()}
    <Button variant="warning" text={buttonText} Icon={Trash2} disabled={!confirmed} loading={processing} onclick={handleConfirm} />
  {/snippet}
</Modal>
